import React, {Component, PropTypes} from 'react'
import cx from 'classnames'
import style from './Selector.less'

class Selector extends Component {
    static propTypes = {
        source: PropTypes.array.isRequired,
        display: PropTypes.func,
        identify: PropTypes.func,
        disable: PropTypes.func,
        kind: PropTypes.string,
        multi: PropTypes.bool,
        bsStyle: PropTypes.string,
        value: PropTypes.any,
        onChange: PropTypes.func,
        onSubmit: PropTypes.func
    }

    static defaultProps = {
        display: (v) => v,
        identify: (v) => v,
        disable: (v) => false
    }

    _toggle(event, item) {
        const {multi, identify, value, onChange, onSubmit} = this.props

        event.preventDefault()

        if (multi) {
            const previousValue = value || []
            const itemId = identify(item)
            const index = previousValue.findIndex((value) => identify(value) == itemId)

            if (index < 0) {
                if (onSubmit) {
                    onSubmit('Add', item)
                }

                if (onChange) {
                    var nextValue = [...previousValue]
                    nextValue.push(item)
                    onChange(nextValue)
                }
            } else {
                if (onSubmit) {
                    onSubmit('Remove', item)
                }

                if (onChange) {
                    var nextValue = [...previousValue]
                    nextValue.splice(index, 1)
                    onChange(nextValue)
                }
            }
        } else {
            if ((value && identify(value)) != identify(item)) {
                if (onSubmit) {
                    onSubmit('Add', item)
                }

                if (onChange) {
                    onChange(item)
                }
            } else {
                if (onSubmit) {
                    onSubmit('Remove', value)
                }

                if (onChange) {
                    onChange(null)
                }
            }
        }
    }

    _isActive(item) {
        const {multi, identify, value} = this.props

        if (multi) {
            const itemId = identify(item)
            return value && value.find((v) => identify(v) == itemId) != null
        } else {
            return (value && identify(value)) == identify(item)
        }
    }

    render() {
        const {source, kind, display, identify, disable, header, after, bsStyle, value, onChange, onSubmit, ...other} = this.props
        const kindClass = kind && kind.toLowerCase()

        const colorStyle = (item, index) => {
            if (this._isActive(item)) return null
            if (kindClass == 'checkbox') return null

            var opacity = 1 - (index * 2 / 10)
            opacity = opacity >= 0.2 && opacity || 0.2
            return 'rgba(213, 221, 229, ' + opacity + ')'
        }

        return (
            <div className={cx(style.default, style[kindClass], {[style.error]: bsStyle == 'error'})}>
                {header}
                <ul className={style.result}>
                    {source.map((item, index) => (
                        <li
                            key={identify(item)}
                            className={cx({[style.active]: this._isActive(item), [style.disabled]: disable(item)})}
                            style={{background: colorStyle(item, index)}}
                            onClick={(e) => !disable(item) && this._toggle(e, item)}>
                            {kindClass == 'checkbox' && (
                                <label>
                                    <input
                                        type='checkbox'
                                        checked={this._isActive(item)} />
                                    <span />
                                </label>
                            )}
                            <div className={style.container}>
                                {display(item)}
                            </div>
                        </li>
                    ))}
                    {after && (
                        <li
                            key='after'
                            className={style.after}>
                            {after}
                        </li>
                    )}
                </ul>
            </div>
        )
    }
}

export default Selector


// WEBPACK FOOTER //
// ./lib/core/components/Selector.js